import useCoreModelsFindAll from 'hooks/useCoreModelsFindAll'

export default (regionIds = []) => useCoreModelsFindAll('region', { where: { id: { isectNotEmpty: regionIds } } })
